module.exports = __webpack_public_path__ + "img/skills.dd17724a.svg";